var map = {
	"./TF.png": 27,
	"./TF_00.png": 28,
	"./TF_01.png": 29,
	"./TF_02.png": 30,
	"./TF_03.png": 31,
	"./TF_04.png": 32,
	"./TF_05.png": 33,
	"./TF_06.png": 34,
	"./TF_07.png": 35,
	"./TF_08.png": 36,
	"./TF_09.png": 37,
	"./TF_10.png": 38,
	"./TF_11.png": 39,
	"./TF_12.png": 40,
	"./TF_13.png": 41,
	"./TF_14.png": 42,
	"./TF_15.png": 43,
	"./TF_16.png": 44,
	"./TF_17.png": 45,
	"./TF_18.png": 46,
	"./TF_19.png": 47,
	"./TF_20.png": 48,
	"./TF_21.png": 49,
	"./TF_22.png": 50,
	"./TF_23.png": 51,
	"./TF_24.png": 52,
	"./TF_25.png": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;